module.exports = __webpack_public_path__ + "img/sol_isol_pain1.477f042b.png";